import React, { useState, useEffect } from 'react';
import { AppTheme, ContractNew, ContractorNew } from '../types';

interface ContractNewFormProps {
  theme: AppTheme;
  contractors: ContractorNew[];
  onSubmit: (data: Omit<ContractNew, 'id' | 'created_at' | 'is_deleted'>) => void;
  onCancel: () => void;
  initialData?: ContractNew;
}

export const ContractNewForm: React.FC<ContractNewFormProps> = ({
  theme,
  contractors,
  onSubmit,
  onCancel,
  initialData
}) => {
  const [formData, setFormData] = useState({
    contractor_id: '',
    sign_date: '',
    amount: 0
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        contractor_id: initialData.contractor_id || '',
        sign_date: initialData.sign_date ? initialData.sign_date.split('T')[0] : '',
        amount: initialData.amount || 0
      });
    }
  }, [initialData]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      contractor_id: formData.contractor_id,
      sign_date: formData.sign_date,
      amount: formData.amount
    });
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '8px',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px',
    backgroundColor: theme.colors.background,
    color: theme.colors.text,
    fontSize: '14px',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    marginBottom: '4px',
    fontWeight: 'bold',
    color: theme.colors.text,
  };

  const buttonStyle: React.CSSProperties = {
    padding: '8px 16px',
    margin: '0 4px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  };

  return (
    <form onSubmit={handleSubmit} style={{ padding: '16px' }}>
      <div style={{ marginBottom: '16px' }}>
        <label style={labelStyle}>Контрагент:</label>
        <select
          value={formData.contractor_id}
          onChange={(e) => setFormData({ ...formData, contractor_id: e.target.value })}
          style={inputStyle}
          required
        >
          <option value="">Выберите контрагента</option>
          {contractors.map((contractor) => (
            <option key={contractor.id} value={contractor.id}>
              {contractor.name}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={labelStyle}>Дата подписания:</label>
        <input
          type="date"
          value={formData.sign_date}
          onChange={(e) => setFormData({ ...formData, sign_date: e.target.value })}
          style={inputStyle}
          required
        />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={labelStyle}>Сумма:</label>
        <input
          type="number"
          step="0.01"
          value={formData.amount}
          onChange={(e) => setFormData({ ...formData, amount: parseFloat(e.target.value) || 0 })}
          style={inputStyle}
          required
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <button
          type="button"
          onClick={onCancel}
          style={{
            ...buttonStyle,
            backgroundColor: theme.colors.border,
            color: theme.colors.text,
          }}
        >
          Отмена
        </button>
        <button
          type="submit"
          style={{
            ...buttonStyle,
            backgroundColor: theme.colors.primary,
            color: 'white',
          }}
        >
          {initialData ? 'Сохранить' : 'Добавить'}
        </button>
      </div>
    </form>
  );
};